export default "__VITE_ASSET__e97yMQz0__"